import {
  buildEventPageViewed,
} from './index'

export const SET_EVENT_VIDEO_VIEW_QUALIFIED = 'SET_EVENT_VIDEO_VIEW_QUALIFIED'
export const SET_EVENT_PAGE_VIEWED = 'SET_EVENT_PAGE_VIEWED'
export const SET_EVENT_VIDEO_AUDIO_CHANGED = 'SET_EVENT_VIDEO_AUDIO_CHANGED'
export const CREATE_SERVER_EVENT = 'CREATE_SERVER_EVENT'
export const SET_EVENT_LEAD = 'SET_EVENT_LEAD'
export const SET_EVENT_DEFAULT = 'SET_EVENT_DEFAULT'
export const SET_AI_GA4_EVENT = 'SET_AI_GA4_EVENT'
export const SET_CONTENT_HIGHLIGHTS_GA4_EVENT = 'SET_CONTENT_HIGHLIGHTS_GA4_EVENT'
export const SET_COMMUNITY_GA4_EVENT = 'SET_COMMUNITY_GA4_EVENT'
export const SET_GA4_VARIABLES = 'SET_GA4_VARIABLES'
export const SET_GA4_INIT_EVENT = 'SET_GA4_INIT_EVENT'

export function setEventVideoAudioChanged (options) {
  const { lang, isLive, isInitial } = options
  return {
    type: SET_EVENT_VIDEO_AUDIO_CHANGED,
    payload: { lang, isLive, isInitial },
  }
}

export function setEventDataVideoViewQualified () {
  return {
    type: SET_EVENT_VIDEO_VIEW_QUALIFIED,
  }
}

export function setEventPageViewed (options) {
  const { auth, location, page } = options
  const event = buildEventPageViewed(options)
  return {
    type: SET_EVENT_PAGE_VIEWED,
    payload: {
      auth, event, location, page,
    },
  }
}

export function setEventLead (email) {
  return {
    type: SET_EVENT_LEAD,
    payload: email,
  }
}

export function setEventDefault (event) {
  return {
    type: SET_EVENT_DEFAULT,
    payload: { event },
  }
}

export function setAiGa4Event (event) {
  return {
    type: SET_AI_GA4_EVENT,
    payload: { event },
  }
}

/**
 * @param {import('immutable').Map} event - Lean GA4 / dataLayer payload
 * @param {Record<string, unknown>} [eventLogExtras] - Warehouse-only fields for eventLog
 */
export function setContentHighlightsGa4Event (event, eventLogExtras = {}) {
  return {
    type: SET_CONTENT_HIGHLIGHTS_GA4_EVENT,
    payload: { event, eventLogExtras },
  }
}

/**
 * @param {import('immutable').Map} event - Lean GA4 / dataLayer payload
 * @param {Record<string, unknown>} [eventLogExtras] - Warehouse-only fields for eventLog
 */
export function setCommunityGa4Event (event, eventLogExtras = {}) {
  return {
    type: SET_COMMUNITY_GA4_EVENT,
    payload: { event, eventLogExtras },
  }
}

export function setGa4Variables (event) {
  return {
    type: SET_GA4_VARIABLES,
    payload: { event },
  }
}

export function setGa4InitEvent () {
  return {
    type: SET_GA4_INIT_EVENT,
  }
}
